import i18n from '@/i18n'
import Store from '@/store'
import ReportHeading from '@/Utils/report-head'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFontsBn from 'pdfmake/build/vfs_fonts_bn'
import pdfFontsEn from 'pdfmake/build/vfs_fonts_en'
import { dateFormat, mobileNumber } from '@/Utils/fliter'

// function getOfficeName (officeId) {
//   return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(hospital => hospital.value === officeId)[0].text
// }
const exportPdfDetails = async (baseUrl, uri = '/report-heading/detail', orgId, reportTitle, followupMains, vm) => {
  try {
      Store.commit('mutateCommonProperties', {
        loading: true
      })
      if (i18n.locale === 'bn') {
        pdfMake.vfs = pdfFontsBn.pdfMake.vfs
      } else {
          pdfMake.vfs = pdfFontsEn.pdfMake.vfs
      }
      // report headings
      const reportHeadfollowupMainsReport = await ReportHeading.getReportHead(baseUrl, uri, orgId)
      const pdfContent = []
      pdfContent.push(
        {
          table: {
            style: 'tablebillingReport',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { image: reportHeadfollowupMainsReport.reportHeadColumn[0].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 },
                { text: vm.$t('production_store.govt_info'), style: 'govt_info', alignment: 'center' },
                { image: reportHeadfollowupMainsReport.reportHeadColumn[1].image, height: 50, width: 50, alignment: 'center', rowSpan: 5 }
              ],
              [
                {},
                { text: reportHeadfollowupMainsReport.orgName, style: 'header2', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadfollowupMainsReport.heading, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportHeadfollowupMainsReport.address, style: 'address', alignment: 'center' },
                {}
              ],
              [
                {},
                { text: reportTitle, style: 'address2', alignment: 'center' },
                {}
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      pdfContent.push(
        {
          table: {
            style: 'tablebillingReport',
            headerRows: 0,
            widths: ['25%', '50%', '25%'],
            body: [
              [
                { text: '', style: 'top' }
              ]
            ]
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        }
      )
      // -------------- Report Body ----------
      // ------------------------------------------------------------------------------------
      // personal information start
      pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.follow_up_progress'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const personalRowsHead = [
          [
            { text: vm.$t('social_service.follow_up_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.$n(followupMains.follow_up_no, { useGrouping: false }), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.follow_up_date') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: dateFormat(followupMains.follow_up_date), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.mobile_no') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: mobileNumber(followupMains.patient_reg_mains.phone_no), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.help_desc_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.support_authority, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.supporting_authority_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.support_authority_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.patient_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.patient_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.register_nid') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: mobileNumber(followupMains.patient_reg_mains.nid_no), style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.father_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.father_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.father_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.father_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.mother_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.mother_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.mother_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.mother_name_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.guardian_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.guardian_name, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.guardian_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.patient_reg_mains.guardian_name_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.relation_patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.relation, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.relation_patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.relation_bn, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '18%', '15%', '18%', '15%', '19%'],
            body: personalRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
      //   // personal information end -----------------
        // Empty Space
        pdfContent.push(
          { text: '', style: 'empty_space' }
        )
        // permanent address start
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.patient_adds'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const permanentAddressRowsHead = [
          [
            { text: vm.$t('globalTrans.division') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDivisionById(followupMains.patient_reg_mains.division_id), style: 'th', alignment: 'left' },
            { text: vm.$t('globalTrans.upazila') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getUpazilaById(followupMains.patient_reg_mains.upazilla_id), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.district') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getDistrictById(followupMains.patient_reg_mains.district_id), style: 'th', alignment: 'left' },
            { text: vm.$t('educational_management.city_corporation') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getCityCorporationById(followupMains.patient_reg_mains.city_corporation_id), style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('globalTrans.union') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getUnionById(followupMains.patient_reg_mains.union_id), style: 'th', alignment: 'left' },
            { text: vm.$t('educational_management.ward') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: vm.getPauroshobaById(followupMains.patient_reg_mains.pauroshoba_id), style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '35%', '15%', '35%'],
            body: permanentAddressRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })
      //   // permanent address end -------------
        // followup_actions start
          const pageBreakRowsHead = [
          [
            { text: '', style: 'th', alignment: 'left', bold: true, pageBreak: 'before' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['100%'],
            body: pageBreakRowsHead
          },
          layout: {
            hLineWidth: function (i, node) {
              return 0
            },
            vLineWidth: function (i, node) {
              return 0
            }
          }
        })
        // Empty Space
        // pdfContent.push(
        //   { text: '', style: 'empty_space', pageBreak: 'before' }
        // )
        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.ac_tk_p_impr_c_s'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
          const familyRowsHead = [
            [
              { text: vm.$t('globalTrans.sl_no'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.action_taken_en'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.action_taken_bn'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.follow_prograss_situation_en'), style: 'th', alignment: 'center' },
              { text: vm.$t('social_service.follow_prograss_situation_bn'), style: 'th', alignment: 'center' }
            ]
          ]
          followupMains.followup_actions.map((report, index) => {
            familyRowsHead.push(
            [
              { stack: [[(index + 1)]], style: 'td', alignment: 'center' },
              { text: report.action, style: 'td', alignment: 'center' },
              { text: report.action_bn, style: 'td', alignment: 'center' },
              { text: report.follow_progress, style: 'td', alignment: 'center' },
              { text: report.follow_progress_bn, style: 'td', alignment: 'center' }
            ])
          })
      pdfContent.push({
        table: {
          headerRows: 1,
          widths: ['10%', '15%', '15%', '30%', '30%'],
          body: familyRowsHead
        }
      })
      //   // followup_actions end -------------
      //   // Other information
        pdfContent.push(
          { text: '', style: 'empty_space' }
        )

        pdfContent.push(
          {
            table: {
              style: 'tablebillingReport',
              headerRows: 0,
              widths: ['25%', '50%', '25%'],
              body: [
                [
                  { text: vm.$t('social_service.other_information'), style: 'th', alignment: 'center', colSpan: '3', bold: true, fillColor: '#dee2e6' },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true },
                  { text: '', style: 'th', alignment: 'center', colSpan: '3', bold: true }
                ]
              ]
            }
          }
        )
        const socioRowsHead = [
          [
            { text: vm.$t('social_service.other_relavant_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.other_info, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.other_relavant_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.other_info_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.comment_patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.patient_comment, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.comment_patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.patient_comment_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.comment_guardian_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.guardian_comment, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.comment_guardian_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.guardian_comment_bn, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.comment_welfare_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.social_officer_comment, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.comment_welfare_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.social_officer_comment_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.recomnd_patient_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.recommendation, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.recomnd_patient_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.recommendation_bn, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.case_close_date') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.case_closing_date, style: 'th', alignment: 'left' },
            { text: vm.$t('social_service.follow_ofc_name_en') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.follower_off_name, style: 'th', alignment: 'left' }
          ],
          [
            { text: vm.$t('social_service.follow_ofc_name_bn') + ': ', style: 'th', alignment: 'left', bold: true },
            { text: followupMains.followup_others.follower_off_name_bn, style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' },
            { text: '', style: 'th', alignment: 'left', bold: true },
            { text: '', style: 'th', alignment: 'left' }
          ]
        ]
        pdfContent.push({
          table: {
            headerRows: 0,
            widths: ['15%', '18%', '15%', '18%', '15%', '19%'],
            body: socioRowsHead
          },
          layout: {
            // hLineWidth: function (i, node) {
            //   return 0
            // },
            // vLineWidth: function (i, node) {
            //   return 0
            // }
          }
        })

        const waterMarkText = i18n.locale === 'bn' ? 'সমাজ কল্যাণ মন্ত্রণালয়' : 'Ministry of Social welfare'
        var docDefinition = {
          info: {
            title: reportTitle
            // use this to change title
            // author: 'john doe',
            // subject: 'subject of document',
            // keywords: 'keywords for document'
            },
        content: pdfContent,
        pageSize: 'A4',
        pageOrientation: 'landscape',
        watermark: { text: waterMarkText, color: 'blue', opacity: 0.1, bold: true, italics: false },
        styles: {
          top: {
            margin: [0, 30, 0, 0]
          },
          top2: {
            margin: [0, 50, 0, 0]
          },
          th: {
            fontSize: 10,
            margin: [3, 3, 3, 3]
          },
          th1: {
              fontSize: 9
            },
          td: {
            fontSize: 8,
            margin: [3, 3, 3, 3]
          },
          header: {
            margin: [0, 1, 0, 15],
            fontSize: 16,
            alignment: 'center'
          },
          header2: {
            border: 0,
            fontSize: 14,
            margin: [0, 0, 0, 1]
          },
          govt_info: {
            margin: [0, 1, 0, 1],
            fontSize: 18,
            alignment: 'center'
          },
          address2: {
            border: 0,
            fontSize: 12,
            bold: true,
            margin: [0, 0, 0, 5]
          },
          empty_space: {
            margin: [10, 10, 10, 10]
          }
          },
          pageBreakBefore: function (currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
            return currentNode.headlineLevel === 1 && followingNodesOnPage.length === 0
         }
        }
        pdfMake.createPdf(docDefinition, null, null, null).print() // use this to change filename ddr
        // pdfMake.createPdf(docDefinition, null, null, null).print() // )
    } catch (error) {
      if (error) {}
    }
    Store.commit('mutateCommonProperties', {
      loading: false
    })
}
export default {
  exportPdfDetails
}
